import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Component, OnInit, signal } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridList, MatGridListModule } from '@angular/material/grid-list';
import { MatDialog } from '@angular/material/dialog';
import { UsersApiService } from '../../Shared/common/users-api.service';
import { any } from '@amcharts/amcharts5/.internal/core/util/Array';
import { BaseEntityModel } from '../../Data/Models/Common/base-entity-model';
import { UserLicenseDetailsModel } from '../../Data/Models/Users/user-license-details-model';
import { LocalStorageService } from '../../Shared/common/local-storage.service';
import { ConfigurationService } from '../../Configuration/configuration.service';
import { AuthConfigService } from '../../Configuration/auth-config.service';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Signal } from '@angular/core';
import moment from 'moment';
import { CharityDataShareServiceService } from '../charity/charities/services/charity-data-share-service.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-licence',
  imports: [
    MatCardModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule, TablerIconsModule, MatIconModule, MatDividerModule, MatGridList, MatGridListModule],
  templateUrl: './licence.component.html',
  styleUrl: './licence.component.scss'
})
export class LicenceComponent implements OnInit {
  currentUser: any;
  userLicenceDetails: any;
  private _userName = signal<string>('');
  // Step 2: Expose it as a readonly Signal
  UserName: Signal<string> = this._userName;
  userEmail: any;
  contactNumber: any;
  addressLine1: any;
  subscriptionType: any;
  subStartDate: any;
  subEndDate: any;
  userCount: any;
  charityCount: any;
  userStatus: any;
  charityStatus: any;
  addressLine2: any;
  addressLine3: any;
  productID: any;
  central_User_ID: number = 0;
  productName: number = 0;
  TableRecordCnt: number = 0;
  numberOfUsers: any;
  planId: number = 0;
  pricingID: number = 0;
  userID: any;
  taxYear: any;
  isLicenceExpired: boolean;
  ShowRenew: boolean;
  leftDays: number;
  countyName: any;
  postCode: any;
  firsttName: string = '';
  lastName: string = '';
  showupgrade: boolean = true;
  noOfCharities: any;
  renew: string | null;
  centralUserID: any;
    renewPopUp: boolean;
    countryName: any;
    city: any;
  expiretoday: boolean = false;
  IsAdmin: boolean = false;
    noofCharitiesSubmitted: number;
  constructor(private dialog: MatDialog, private userAPIService: UsersApiService, private localStorageService: LocalStorageService, private authconfigService: AuthConfigService, private dataShareService: CharityDataShareServiceService
    , private authService: AuthService) { }
  close() {
    debugger
    this.dialog.closeAll();
   // this.licenceValidations('open'); // Call the validation method if allowed
  }
  ngOnInit() {
    this.viewUserLicenceDetails();
    debugger
    if (localStorage.getItem("isLicenceExpired") == "true") {
      debugger
      this.showupgrade = false;
    }
    
  }


  viewUserLicenceDetails() {
    debugger
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      this.currentUser = parsedUser.userID;

    }
    this.userAPIService.getUserLicenseDetails(this.currentUser).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
      debugger
      if (data.status == 0) {
        if (data.entity != null && data.entity.length > 0) {

          this.userLicenceDetails = data.entity[0]
          this._userName.set(data.entity[0].userName)
          this.firsttName = data.entity[0].firsttName
          this.lastName = data.entity[0].LastName
          this.userEmail = data.entity[0].emailID
          this.contactNumber = data.entity[0].contactNumber
          this.addressLine1 = data.entity[0].addressLine1
          this.addressLine2 = data.entity[0].addressLine2
          this.addressLine3 = data.entity[0].addressLine3
          this.subscriptionType = data.entity[0].registrationType
          this.subStartDate = data.entity[0].tuCreatedDate
          this.subStartDate = moment(this.subStartDate).format("DD/MM/YYYY");// for time HH:mm:ss
          this.subEndDate = data.entity[0].tuEndDate
          this.subEndDate = moment(this.subEndDate).format("DD/MM/YYYY");// for time HH:mm:ss
          this.userCount = data.entity[0].noOfUsersCreated
          this.charityCount = data.entity[0].noofCharitiescreated
          this.userStatus = data.entity[0].userStatus
          this.productID = data.entity[0].productID
          this.productName = data.entity[0].productName
          this.central_User_ID = data.entity[0].central_User_ID
          this.TableRecordCnt = data.entity[0].totalNoofCharitiescreated
          this.noofCharitiesSubmitted = data.entity[0].noofCharitiesSubmitted
         // this.numberOfUsers = data.entity[0].number_Of_Users;
          this.planId = data.entity[0].planId;
          this.pricingID = data.entity[0].pricingId;
          this.countryName = data.entity[0].countryName
          this.city = data.entity[0].city
          this.postCode = data.entity[0].postCode;
          this.countyName = data.entity[0].countyName;
         // this.noOfCharities = data.entity[0].noOfCharities;
          this.numberOfUsers = data.entity[0].number_Of_Users >= 99999 ? 'Unlimited' : data.entity[0].number_Of_Users;
          this.noOfCharities = data.entity[0].noOfCharities >= 99999 ? 'Unlimited' : data.entity[0].noOfCharities;
          this.IsAdmin = data.entity[0].isAdmin;


          var today = new Date();
          var licenseEndDate = moment(data.entity[0].tuEndDate, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
          var today1 = moment(today, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
         // licenseEndDate = moment(licenseEndDate, "DD/MM/YYYY")
          var diffDays = (moment(licenseEndDate, "DD/MM/YYYY").diff(moment(today1, "DD/MM/YYYY"), "days"));
          (diffDays < 0) ? this.isLicenceExpired = true : this.isLicenceExpired = false;
          var date = new Date();
          if (diffDays >= 0 && diffDays <= 30) {
            this.expiretoday = diffDays == 0;
            this.leftDays = diffDays
            this.ShowRenew = true;
          }
          else if (diffDays < 0) {
            this.ShowRenew = true;
          }
        }
      }

    })

  }


  Upgrade(Type: any) {
    debugger
    this.userAPIService.getUserLicenseDetails(this.currentUser).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
      debugger
      if (data.entity[0].userStatus == true) {
        var centralUserID = (this.central_User_ID).toString();

        var subscriptionURL = this.authconfigService.getSubscriptionAPIUrl();
        var prodId = (this.productID).toString();
        prodId = prodId.split('+').join('vkanslab');

        var encryptedDataProdID = CryptoJS.AES.encrypt(prodId, "My Secret Passphrase");
        var ProductID = encryptedDataProdID.toString();
        ProductID = ProductID.split('+').join('vkanslab');

        var encryptedData1 = CryptoJS.AES.encrypt(centralUserID, "My Secret Passphrase");
        var centralUserId = encryptedData1.toString();
        centralUserId = centralUserId.split('+').join('vkanslab');

        var name = ''
        if (Type == 'Upgrade') {
          var encryptedData2 = CryptoJS.AES.encrypt("Upgrade", "My Secret Passphrase");
          name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        } else if (Type == 'Renew') {
          var encryptedData2 = CryptoJS.AES.encrypt("Renew", "My Secret Passphrase");
          name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        }



        var encryptedData3 = CryptoJS.AES.encrypt(this.TableRecordCnt + "", "My Secret Passphrase");
        var numberOfCharitiesCreated = encryptedData3.toString();
        numberOfCharitiesCreated = numberOfCharitiesCreated.split('+').join('vkanslab');


        var encryptedData4 = CryptoJS.AES.encrypt("Annually", "My Secret Passphrase");
        var subType = encryptedData4.toString();
        subType = subType.split('+').join('vkanslab');


        var numOfUsers = this.numberOfUsers + "";
        var encryptedData5 = CryptoJS.AES.encrypt(numOfUsers, "My Secret Passphrase");
        var numberOfUsers = encryptedData5.toString();
        numberOfUsers = numberOfUsers.split('+').join('vkanslab');

        var StatusFrom = ''
        var PlanId = ''
        var PricingID = ''
        //upgrade from users
        if (Type == 'Upgrade' || Type == 'Renew') {
          var encryptedData6 = CryptoJS.AES.encrypt("FromCompanies", "My Secret Passphrase");
          StatusFrom = encryptedData6.toString();
          StatusFrom = StatusFrom.split('+').join('vkanslab');
          var encryptedDataPlanId = CryptoJS.AES.encrypt(this.planId + "", "My Secret Passphrase");
          PlanId = encryptedDataPlanId.toString();
          PlanId = PlanId.split('+').join('vkanslab');
          var encryptedDataPricingID = CryptoJS.AES.encrypt(this.pricingID + "", "My Secret Passphrase");
          PricingID = encryptedDataPricingID.toString();
          PricingID = PricingID.split('+').join('vkanslab');
        }
        debugger;
        var URL = "";
        //subscriptionURL ='https://subscriptions.dev.acuitysoft.com'   //for testing
        if (Type == 'Renew' || Type == 'Upgrade') {
          URL = subscriptionURL + "/payment/plandetails/CustomerPlans?ProductName=" + ProductID + "&centralUserId=" + centralUserId + "&regType=" + name + "&numberOfCompanies=" + numberOfCharitiesCreated + "&subType=" + subType + "&RegUsers=" + numberOfUsers + "&StatusFrom=" + StatusFrom + "&PlanId=" + PlanId + "&PricingId=" + PricingID;
        }
        else {
          URL = subscriptionURL + "/payment/plandetails/CustomerPlans?ProductName=" + ProductID + "&centralUserId=" + centralUserId + "&regType=" + name + "&numberOfCompanies=" + numberOfCharitiesCreated + "&subType=" + subType + "&RegUsers=" + numberOfUsers + "&StatusFrom=" + StatusFrom + "&PlanId=" + PlanId + "&PricingId=" + PricingID;
        }
        window.open(URL, '_self');
      } else {
        Swal.fire('', "This software license is deactivated .please contact Andica Sales.");
        return;
      }
    });
  }

  //licenceValidations(flag: string): void {
  //  debugger
  //  this.checkRenew();
  //  const licenceDetails = this.authService.currentUserLicenseDetailsValue;
  //  if (licenceDetails && moment(licenceDetails.tuEndDate).diff(new Date(), 'days') <= 30 && flag === 'open') {
  //    const todayExact = moment().format("DD/MM/YYYY HH:mm:ss");
  //    const licenseEndDate = moment(licenceDetails.tuEndDate).format("DD/MM/YYYY HH:mm:ss");
  //    const ms = moment(licenseEndDate, "DD/MM/YYYY HH:mm:ss").diff(moment(todayExact, "DD/MM/YYYY HH:mm:ss"));

  //    if (ms <= 0) {
  //      this.renew = localStorage.getItem("isLicenceExpired");
  //      if (this.renew = 'true') {
  //        this.isLicenceExpired = true;
  //        localStorage.setItem("isLicenceExpired", "true");
  //        const message = "Andica Charity Accounts Software licence has expired on "
  //          + moment(licenceDetails.tuEndDate).format("DD/MM/YYYY") + ". ";

  //        Swal.fire({
  //          title: "Andica Charity Accounts",
  //          text: message,
  //          icon: "warning",
  //          allowOutsideClick: false,
  //          showCancelButton: false,
  //          confirmButtonText: "Renew"
  //        }).then((result) => {
  //          if (result.isConfirmed) {
  //            this.dialog.open(LicenceComponent, { width: '60%', maxWidth: '100%', disableClose: true});
  //          }
  //        });
  //      }
  //    }  
  //    // Mark validation done and hide popup
  //    this.dataShareService.markValidated();
  //  }
  //}


  checkRenew() {
    debugger
    const storedValue = sessionStorage.getItem('id_token_claims_obj');
    if (storedValue) {
      var email = JSON.parse(storedValue);
    }
    if (email) {
      var email = email.emails[0]             
    }  
    this.authService.logIn(email)
      .subscribe((res) => {
        debugger
        if (res.status == 0) {
          //Navigate to to the page based on returnUrl
          if (res.entity != null) {
            this.localStorageService.setCurrentUser(res.entity[0]);
            this.authService.currentUserSubject.next(res.entity[0]);
            this.authService.checkUserLicenseDetails();
            // this.dataShareService.setShowExpirePopup(true);
            localStorage.setItem("CurrentuserID", res.entity[0].userID.toString());
            const currentUser = localStorage.getItem('currentUser');
            if (currentUser) {
              const parsedUser = JSON.parse(currentUser);
              this.centralUserID = parsedUser.centralUserID;
            }
          }

        }
      })
      }
}
